import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getScenarioData } from 'src/redux/async/bomAnalysis/bomAnalysisAsync'
import {
  getProjectAndScenarioNamesBidAnalysisAsync,
  getRFPFileDataAsync,
} from 'src/redux/async/rfxManagement/rfpManagementAsync'

const initialState = {
  filterModels: {},
  filterChangedFrom: null,
  getFileDataLoader: false,
  getScenarioAndProjectNamesLoader: false,
  filterColumnOnChange: null,
  actualChangeFilterField: null,
  checkOnLast: null,
  bidAnalysisDefaultCurrency: '$',
  selectedScopeProjectName: null,
  selectedScopeScenarioName: null,
  isBidAnalysisValid: false,
  selectedAllValues: false,
  isClearFilter: false,
}
export const productWiseViewSlice = createSlice({
  name: 'bid-analysis/product-wise-view',
  initialState,
  extraReducers: (builder) => {
    // get initial bid data
    builder.addMatcher(isAnyOf(getRFPFileDataAsync.pending), (state) => {
      state.getFileDataLoader = true
    })
    builder.addMatcher(isAnyOf(getRFPFileDataAsync.fulfilled), (state, action) => {
      state.getFileDataLoader = false
    })
    builder.addMatcher(isAnyOf(getRFPFileDataAsync.rejected), (state, action) => {
      state.getFileDataLoader = false
    })
    // getScenarioData
    builder.addMatcher(isAnyOf(getScenarioData.pending), (state) => {
      state.getFileDataLoader = true
    })
    builder.addMatcher(isAnyOf(getScenarioData.fulfilled), (state, action) => {
      state.getFileDataLoader = false
    })
    builder.addMatcher(isAnyOf(getScenarioData.rejected), (state, action) => {
      state.getFileDataLoader = false
    })

    // round level scenario and project names
    builder.addMatcher(isAnyOf(getProjectAndScenarioNamesBidAnalysisAsync.pending), (state) => {
      state.getScenarioAndProjectNamesLoader = true
    })
    builder.addMatcher(
      isAnyOf(getProjectAndScenarioNamesBidAnalysisAsync.fulfilled),
      (state, action) => {
        state.getScenarioAndProjectNamesLoader = false
      },
    )
    builder.addMatcher(
      isAnyOf(getProjectAndScenarioNamesBidAnalysisAsync.rejected),
      (state, action) => {
        state.getScenarioAndProjectNamesLoader = false
      },
    )
  },
  reducers: {
    setIsBidAnalysisValid: (state, action) => {
      state.isBidAnalysisValid = action.payload
    },
    setScopesData: (state, action) => {
      state[action.payload.type] = action.payload.value
    },
    setBidAnalysisDefCurrency: (state, action) => {
      state.bidAnalysisDefaultCurrency = action.payload
    },
    setActualChangeFilterField: (state, action) => {
      state.actualChangeFilterField = action.payload
    },
    setCheckOnLast: (state, action) => {
      state.checkOnLast = action.payload
    },
    setFilterColumnOnChange: (state, action) => {
      state.filterColumnOnChange = action.payload
    },
    setFilterModels: (state, action) => {
      state.filterModels = action.payload
    },
    setFilterChangedFrom: (state, action) => {
      state.filterChangedFrom = action.payload
    },
    setSelectedAllValues: (state, action) => {
      state.selectedAllValues = action.payload
    },
    setToInitialProductWiseView: () => {
      return initialState
    },
    setIsClearFilter: (state, action) => {
      state.isClearFilter = action.payload
    },
  },
})

export const {
  setFilterModels,
  setFilterChangedFrom,
  setFilterColumnOnChange,
  setActualChangeFilterField,
  setCheckOnLast,
  setBidAnalysisDefCurrency,
  setScopesData,
  setIsBidAnalysisValid,
  setSelectedAllValues,
  setToInitialProductWiseView,
  setIsClearFilter
} = productWiseViewSlice.actions
export default productWiseViewSlice.reducer
